import React from 'react';
import { motion } from 'framer-motion';

import { images } from '../../../constants';
import './About.css';

const About = () => (
  <div id="how" className="app__container app__whitebg">
    <div className="app__wrapper app__flex">
      <motion.div
        whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__about app__flex"
      >
        <div className="about-header">
          <h1 className="head-text">The <span>4-Step</span> Journey to Your "Yes!"</h1>
          <p>Crafting the perfect proposal is easier than you think! Follow these simple steps to create a unique and unforgettable experience for your loved one.</p>
        </div>
        <div className="app__profiles">
          <motion.div
            whileInView={{ x: [-100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="app__profile-item"
          >
            <h3>Step 1</h3>
            <img src={images.StepI} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>Account Creation</h2>
            <p className="p-text" style={{ marginTop: 10 }}>Create your free account in seconds.</p>
          </motion.div>
          <motion.div
            whileInView={{ y: [-100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="app__profile-item"
          >
            <h3>Step 2</h3>
            <img src={images.StepII} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>Page Creation & Personalize</h2>
            <p className="p-text" style={{ marginTop: 10 }}>Design your unique proposal page.</p>
          </motion.div>
        </div>
        <div className="app__profiles">
          <motion.div
            whileInView={{ y: [100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="app__profile-item"
          >
            <h3>Step 3</h3>
            <img src={images.StepIII} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>Link Sharing</h2>
            <p className="p-text" style={{ marginTop: 10 }}>Generate a unique link to share with your loved one.</p>
          </motion.div>
          <motion.div
            whileInView={{ x: [100, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="app__profile-item"
          >
            <h3>Step 4</h3>
            <img src={images.StepIV} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>Waiting...</h2>
            <p className="p-text" style={{ marginTop: 10 }}>Anticipate the moment with excitement!</p>
          </motion.div>
        </div>
      </motion.div>
    </div>
  </div>
);

export default About;
